
export async function downloadFileFromS3(presignedUrl: string, fileName: string) {
  const response = await fetch(presignedUrl);
  if (!response.ok) {
    throw new Error();
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export function downloadLinkFileFromS3(presignedUrl: string) {
  const a = document.createElement('a');
  a.href = presignedUrl;
  document.body.appendChild(a);
  a.click();
  a.remove();
}